import React, { useContext, useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";

interface DisabledAndLoading {
  loading: boolean;
  disabled: boolean;
  setDisabled: (disabled: boolean) => void;
  setLoading: (loading: boolean) => void;
  /**
   * True if either loading or disabled
   */
  either: boolean;
}

/**
 * Context for managing both loading and disabled state. Exposes either which is true if either loading or disabled is true.
 * @param {boolean} initialDisabled
 * @param {boolean} initialLoading
 * @returns {DisabledAndLoading}
 */
export function useDisabledAndLoading(
  initialDisabled: boolean = false,
  initialLoading: boolean = false
): DisabledAndLoading {
  const [disabled, setDisabled] = useState(initialDisabled);
  const [loading, setLoading] = useState(initialLoading);
  const [either, setEither] = useState(initialDisabled || initialLoading);

  useEffect(() => setLoading(initialLoading), [initialLoading]);
  useEffect(() => setDisabled(initialDisabled), [initialDisabled]);

  const handleSetLoading = (value: boolean) => {
    setDisabled(value);
    setLoading(value);
  };

  useEffect(() => setEither(disabled || loading), [disabled, loading]);

  return { disabled, loading, setLoading: handleSetLoading, setDisabled, either };
}

export const DisabledAndLoadingContext = React.createContext<DisabledAndLoading>(null);

export function DisabledAndLoadingCircle() {
  const disabledAndLoading = useContext(DisabledAndLoadingContext);
  return disabledAndLoading.loading ? <CircularProgress size={18} color="primary" /> : null;
}
